import _ from 'lodash';
import numeral from 'numeral';
import accountingAPI from '@/api/accounting';

export default {
  async updateInvoiceTotals (id, invoice) {
    const lines = await accountingAPI.getLineItems(id);
    invoice.original_amount = 0;
    invoice.amount_os = 0;
    for (let i = 0; i < lines.length; i++) {
      invoice.original_amount += lines[i].is_warranty ? 0 : _.add(lines[i].subtotal, lines[i].tax);
    }

    invoice.original_amount = + parseFloat(invoice.original_amount).toFixed(2);

    const payments = await accountingAPI.getInvoicePayments(invoice.id);
    const paymentsTotal = _.sumBy(payments, 'amount');
    invoice.amount_os = invoice.original_amount - paymentsTotal;
    invoice.amount_os = + parseFloat(invoice.amount_os).toFixed(2);
    invoice = await accountingAPI.updateInvoice(id, invoice);
    return invoice;
  },
  async duplicateInvoice (inv) {
    let newInv = _.cloneDeep(inv)
    newInv.id = null
    newInv.number = null
    newInv = await accountingAPI.createInvoice(inv)
    let lines = await accountingAPI.getLineItems(inv.id)

    for (let i = 0; i < lines.length; i++) {
        lines[i].id = null
        lines[i].invoice = newInv.id
        await accountingAPI.createLineItem(lines[i])
    }
    return newInv
  },
  getReportAmountDisplay (val) {
    if (val !== 0) {
      val = Math.round(val * 100) / 100
      if (val < 0) {
        return numeral(val).format('(0,0.00)')
      }
      return numeral(val).format('0,0.00')
    }
    return '-'
  }
}
